module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('a', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-239bd5a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1803
// module chunks = 1